<template>
<div id="">
  <v-container fluid class="pt-0 ">
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card style="min-height:85vh" class="admin_secondary">
          <v-card-title class="secondary white--text">
            {{section_labels[section]}} Video
            <v-spacer></v-spacer>
            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
          </v-card-title>
          <v-container class=" white--text">
            <v-row align="center" justify="space-between">

              <v-col cols="12" md="4" lg="3" xl="2">
                <v-text-field v-model="search" append-icon="fa-search" dark label="Search" outlined hide-details clearable></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="3" xl="2">
                <v-select outlined hide-details clearable dark label="Status" placeholder="All" :items="['Pending','Approved']" v-model="filter_status"></v-select>
              </v-col>


            </v-row>
            <v-data-table :loading="loading"  :headers="headers" :items="profileVideos" :search="search">

              <template v-slot:item.name="{ item }">
                <router-link  :to="`/admin/users/${item.account.id}`">{{item.name}}</router-link>
                </template>

              <template v-slot:item.date_added="{ item }">
                  {{item.date_added | fromNow}}
                  </template>

              <template v-slot:item.approved="{ item }">
                    <span :class="`${item.approved===1 ? 'green' : 'blue'}--text`">{{item.approved===1 ? 'Approved' : 'Pending'}}</span>
                      </template>


              <template v-slot:item.notification="{ item }">
                        <v-btn icon small color="primary" @click="$eventBus.$emit('send_notification',{account:item.account})"><v-icon small>fa-paper-plane</v-icon></v-btn>
                      </template>


            </v-data-table>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</div>
</template>
<script>
import headersSimple from "./headers_simple.json"


export default {
  name: "",
  data: () => ({
    search: '',
    filter_status: null,
    show_deleted: false,
    loading: false,
    accounts: [],
    profile_videos: [],
    section_labels: {
      1: "Interests",
      2: "Work Experience",
      3: "Thank You"
    }
  }),
  computed: {
    headers() {
      return headersSimple
    },
    section() {
      return parseInt(this.$route.params.section)
    },
    profileVideos() {
      return this.profile_videos.filter(function(video) {
        if (video.deleted && this.show_deleted === false) {
          return false
        }
        if (this.filter_status) {
          if (this.filter_status === "Pending" && video.approved !== 0) {
            return false
          }
          if (this.filter_status === "Approved" && video.approved !== 1) {
            return false
          }
        }
        return video.section === this.section
      }.bind(this)).map(function(video) {
        video.account = this.accounts.find(a => {
          return a.id === video.account_id
        })
        video.name = video.account.name
        video.time_outstanding = this.$helpers.fromNow(video.date_added)
        return video
      }.bind(this))
    }
  },
  methods: {
    async load() {
      this.loading = true

      let data = await Promise.all([this.$api(`/account/admin/accounts`), this.$api(`/account/admin/profile-videos`)])
      this.accounts = data[0]
      this.profile_videos = data[1]

      this.loading = false
    }
  },
  created() {
    this.load()
  }
}
</script>
<style lang="scss" scoped>
</style>
